import Vue from 'vue';
import axios from 'axios';

export default {
	namespaced: true,
	state: {
		token: localStorage.getItem('authToken') || '',
		status: '',
	},
	mutations: {
		REQUEST_AUTHENTICATION(state) {
			state.status = 'loading';
		},
		AUTH_SUCCESS(state, payload) {
			state.status = 'success';
			state.token = payload;
		},
		AUTH_ERROR(state) {
			state.status = 'error';
			localStorage.removeItem('authToken');
			state.token = '';
		},
		AUTH_LOGOUT(state) {
			state.status = 'loggedout';
			localStorage.removeItem('authToken');
			state.token = '';
		},
	},
	actions: {
		async changePassword(context, { OldPassword, NewPassword, NewPasswordConfirmation }) {
			const response = await Vue.callAPI({
				method: 'POST',
				path: '/changepassword',
				data: {
					OldPassword,
					NewPassword,
					NewPasswordConfirmation,
				},
			});

			return response;
		},

		saveProfile(context, {
			FullName, EMailAddress, Country, Intention, YouTubeChannelURL,
		}) {
			const response = Vue.callAPI({
				method: 'POST',
				path: '/saveprofile',
				data: {
					FullName,
					EMailAddress,
					Country,
					Intention,
					YouTubeChannelURL,
				},
			});

			return response.data;
		},

		requestPasswordReset(context, { email }) {
			return Vue.callAPI({
				method: 'post',
				path: `/user/request-reset-password?email=${encodeURIComponent(email)}`,
			});
		},
		resetPassword(context, { token, password }) {
			return Vue.callAPI({
				method: 'post',
				path: `/user/reset-password?token=${token}&password=${encodeURIComponent(password)}`,
			});
		},

		async requestSignup(context, { EMailAddress }) {
			return Vue.callAPI({
				method: 'POST',
				path: '/signup',
				data: {
					EMailAddress,
				},
			});
		},

		async getSignupData(context, token) {
			try {
				const response = await Vue.callAPI({
					method: 'GET',
					path: `/getsignup/${token}`,
				});

				if (response.data.Data.Type === 'referrer') {
					return {};
				}

				return response.data.Data.Signup;
			} catch (error) {
				if (error.response.status === 404) {
					this.router.push({ name: 'Login' });
					Vue.notify({
						duration: 6000,
						type: 'error',
						title: '',
						text: 'oops! Something went wrong.',
					});
				}
				return error;
			}
		},

		async finishingSignup({ dispatch }, {
			Token,
			UserName,
			Password,
			FullName,
			EMailAddress,
			Country,
			Intention,
			YouTubeChannelURL,
			InvitationCode,
		}) {
			try {
				await Vue.callAPI({
					method: 'POST',
					path: '/signup/details',
					data: {
						Token,
						UserName,
						Password,
						FullName,
						EMailAddress,
						Country,
						Intention,
						YouTubeChannelURL,
						InvitationCode,
					},
				});

				return dispatch('requestAuthentication', { username: UserName, password: Password });
			} catch (error) {
				return Promise.reject();
			}
		},

		async requestAuthentication({ commit }, { username, password, saveToken = true }) {
			try {
				commit('REQUEST_AUTHENTICATION');

				const response = await Vue.callAPI({
					method: 'POST',
					path: '/loginuser',
					data: {
						username,
						password,
					},
				});

				const token = response.data.RedirToken;

				axios.defaults.headers.common['RediR-Token'] = token;

				commit('AUTH_SUCCESS', token);

				if (saveToken) {
					localStorage.setItem('authToken', token);
				}
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					title: 'Login Failed',
					text: 'Failed to authenticate. Please try again',
				});
				commit('AUTH_ERROR', error);
				throw error;
			}
		},
		async logoutUser({ dispatch }) {
			await Vue.callAPI({
				method: 'GET',
				path: '/logoutuser',
			});

			return dispatch('removeAuthentication');
		},
		removeAuthentication(context) {
			this._vm.$intercom.shutdown();
			axios.defaults.headers.common['RediR-Token'] = '';
			context.commit('AUTH_LOGOUT');
		},
		initAuthentication({ state }) {
			const { token } = state;

			if (token) {
				axios.defaults.headers.common['RediR-Token'] = token;
			}
		},
	},
	getters: {
		isAuthenticated: (state) => !!state.token,
		authStatus: (state) => state.status,
	},
};
